// extracted by mini-css-extract-plugin
export var container = "_px-0";
export var dotAnimation = "_px-2";
export var dotsLoading = "_px-1";